<template>
    <b-form @submit.prevent="submit">
        <b-alert :show="!!errorMessage" fade :variant="errorVariant">{{errorMessage}}</b-alert>

        <b-input ref="valueInput"
                 v-model.trim="scanValue" class="d-inline-block mr-2"
                 :key="isProcessing /*For re-triggering the autofocus*/"
                 :inputmode="inputFocusedManually ? 'text' : 'none'"
                 :disabled="isProcessing"
                 @click="inputFocusedManually = true"
                 type="text"
                 style="width:230px;"
                 placeholder="EAN code"
                 required
                 autofocus
                 autocomplete="off"
        />

        <b-button variant="primary" type="submit" :disabled="isProcessing">
            <span v-if="!isProcessing">Scan</span>
            <font-awesome-icon v-else icon="spinner" spin/>
        </b-button>
    </b-form>
</template>

<script>
import {UsesProductProcessApi} from "./UsesProductProcessApi";

export default {
    extends: UsesProductProcessApi,
    name: "ProductScanSort",

    data() {
        return {
            isProcessing: false,
            isUnableToShipMode: false,
            scanValue: '',
            errorVariant: '',
            errorMessage: '',
            inputFocusedManually: false,
            refocusInterval: setInterval(() => this.$refs['valueInput']?.focus(), 1000),
        }
    },

    computed: {},

    mounted() {

    },

    methods: {
        submit() {
            if (this.isProcessing) {
                return
            }

            this.isProcessing = true
            this.errorMessage = ''
            this.scanValue = this.scanValue.padStart(13, '0')

            this.$http.get(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/storage-locations/${this.storageZoneIdentifier}/process-product/${this.processType}/scan/${this.scanValue}`, {
                params: this.postData,
            })
                .then(response => {
                    clearInterval(this.refocusInterval)
                    this.$emit('success', this.scanValue, structuredClone(response.data.dispatch_request), structuredClone(response.data.line), response.data.storage_location, response.data.is_last_scan)
                })
                .catch(e => {
                    if (e.response.status === 404) {
                        this.errorMessage = `Product niet gevonden`
                        this.errorVariant = 'warning'
                    }
                    else {
                        this.errorMessage = `Fout bij het verwerken. Probeer het opnieuw.`
                        this.errorVariant = 'danger'
                    }

                    this.scanValue = ''
                    this.isProcessing = false
                })
        },
    },

    watch: {
        scanValue(val) {
            if (val.match(/^[0-9]{13}$/)) {
                this.submit()
            }
        },
    }
}
</script>
